import { render, staticRenderFns } from "./MemberRosterConfiguration.vue?vue&type=template&id=4b8ee2a2&scoped=true&"
import script from "./MemberRosterConfiguration.vue?vue&type=script&lang=js&"
export * from "./MemberRosterConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./MemberRosterConfiguration.vue?vue&type=style&index=0&id=4b8ee2a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8ee2a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b8ee2a2')) {
      api.createRecord('4b8ee2a2', component.options)
    } else {
      api.reload('4b8ee2a2', component.options)
    }
    module.hot.accept("./MemberRosterConfiguration.vue?vue&type=template&id=4b8ee2a2&scoped=true&", function () {
      api.rerender('4b8ee2a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamMembers/components/MemberRosterConfiguration.vue"
export default component.exports